// extracted by mini-css-extract-plugin
module.exports = {"metalTypesWrapper":"MetalChoices_metalTypesWrapper__ZEXdu","choices":"MetalChoices_choices__2RuiN"};